const rawBase = (process.env.VUE_APP_API_BASE ?? "http://localhost:5001").replace(/\/+$/, "");
let prefix = (process.env.VUE_APP_API_PREFIX || "").trim();
if (prefix && !prefix.startsWith("/")) prefix = `/${prefix}`;
const baseWithPrefix = prefix ? rawBase + prefix : rawBase;
const isLocalHttps =
  baseWithPrefix.startsWith("https://localhost") ||
  baseWithPrefix.startsWith("https://127.0.0.1");
const API_BASE = isLocalHttps ? baseWithPrefix.replace(/^https:\/\//, "http://") : baseWithPrefix;

export default API_BASE;
